<template>
  <div class="afm-select-container"
       @mouseenter="mouseenter"
       @mouseleave="mouseleave"
       @click="changeIsShowOption">
    <div class="afm-select-top-container">
      <input type="text" :value="showFilterKey" :placeholder="placeholder" @click="changeIsShowOption">
      <div :class="isShowOption ? 'afm-select-top-arrow' : 'afm-select-bottom-arrow'"></div>
    </div>
    <div class="option-container" v-show="isShowOption">
      <div v-for="item in optionList"
           :key="item.value"
           :value="item.value"
           class="option-item"
           :class="{'option-item-actived': filterKey === item.value}"
           @click.stop="changeFilterKey(item)">
        {{$i18n.locale === 'en' ? item.label_en : item.label_ch}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "afm-select",
  model: {
    prop: 'filterKey',
    event: 'input'
  },
  props: {
    optionList: {
      type: Array,
      required: true
    },
    filterKey: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    hoverIsShow: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isShowOption: false,
      showFilterKey: ''
    }
  },
  methods: {
    changeFilterKey(item) {
      this.isShowOption = false
      this.$emit('input', item.value)
      this.$emit('change', item)
    },
    changeIsShowOption() {
      this.isShowOption = !this.isShowOption
    },
    formatFilterKey(val) {
      const {optionList, $i18n} = this
      if (!optionList) {
        return ''
      }
      let resItem = optionList.find(item => item.value === val)
      return resItem ? ($i18n.locale === 'en' ? resItem.label_en : resItem.label_ch) : ''
    },
    mouseenter() {
      if (!this.hoverIsShow) {
        return
      }
      this.isShowOption = true
    },
    mouseleave() {
      if (!this.hoverIsShow) {
        return
      }
      this.isShowOption = false
    }
  },
  watch: {
    filterKey: {
      immediate: true,
      handler(newVal) {
        this.showFilterKey = this.formatFilterKey(newVal)
      }
    },
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.showFilterKey = this.formatFilterKey(this.filterKey)
      }
    }
  }
}
</script>

<style lang="less">
.afm-select-container {
  position: relative;
  cursor: pointer;
  width: 150px;

  .afm-select-top-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    input {
      pointer-events: none;
      border: none;
      font-family: "Source Sans Pro";
      outline: none;
      font-size: 22px;
      font-weight: 600;
      color: #818181;
      padding: 3px 7px;
      max-width: 100%;
    }

    .afm-select-bottom-arrow, .afm-select-top-arrow {
      width: 0;
      height: 0;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 11px solid #818181;
      transition: 0.3s;
      position: absolute;
      right: 0;
    }

    .afm-select-bottom-arrow {
      transform: rotate(0);
    }

    .afm-select-top-arrow {
      transform: rotate(180deg);
    }
  }

  .option-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    width: 100%;

    .option-item {
      cursor: pointer;
      padding: 2px 7px;
      width: 100%;

      &:hover {
        color: #7cc26a;
      }
    }

    .option-item-actived {
      color: #7cc26a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afm-select/afm-select.vue